import { ActionTree } from 'vuex';
import { RootState } from '@/plugins/store';
import { AuthenticationState } from './state';

export const actions: ActionTree<AuthenticationState, RootState> = {

};
